import { render, staticRenderFns } from "./dialog_transPet.vue?vue&type=template&id=5d0b241f&scoped=true&"
import script from "./dialog_transPet.vue?vue&type=script&lang=js&"
export * from "./dialog_transPet.vue?vue&type=script&lang=js&"
import style0 from "./dialog_transPet.vue?vue&type=style&index=0&id=5d0b241f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b241f",
  null
  
)

export default component.exports